import React, { useEffect } from "react";
import { Globe } from "lucide-react";

const AdCard = ({ publisherId, slotId, darkMode }) => {
  const dm = darkMode;
  useEffect(() => {
    if (publisherId && slotId) {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        // AdSense errors are expected (e.g. ad blockers, test environments) — intentionally silent
      }
    }
  }, [publisherId, slotId]);

  if (!publisherId) {
    return (
      <div className={`rounded-2xl flex flex-col items-center justify-center p-8 border-2 border-dashed ${dm ? "border-white/5 bg-[#1a2122]/40" : "border-black/5 bg-[#f3f4f5]/40"}`} style={{ minHeight: 180 }}>
        <Globe className={`w-4 h-4 mb-1.5 opacity-20 ${dm ? "text-slate-400" : "text-[#6b7a7d]"}`} />
        <span className={`category-tag opacity-30 ${dm ? "text-slate-500" : "text-[#bac9cc]"}`}>Sponsored</span>
      </div>
    );
  }
  return (
    <div className={`rounded-2xl overflow-hidden ${dm ? "bg-[#1a2122]" : "bg-white"}`} style={{ minHeight: 180, boxShadow: "0 0 0 1px rgba(186,201,204,0.08)" }}>
      <p className={`px-4 pt-3 pb-1 category-tag ${dm ? "text-slate-600" : "text-[#d9dadb]"}`}>Sponsored</p>
      <ins className="adsbygoogle" style={{ display: "block" }} data-ad-client={publisherId} data-ad-slot={slotId} data-ad-format="auto" data-full-width-responsive="true" />
    </div>
  );
};

export default AdCard;
